import { BaseService } from './base-service';
import { SandboxExistsReportDTO, SandboxSendReportDTO } from '@/core/dto/sandbox';

class SandboxService extends BaseService<void> {
    constructor(public readonly basePath: string = '/sandbox') {
        super();
    }

    async sendReport(params: SandboxSendReportDTO): Promise<void> {
        await this.getInstance().post<void>(this.basePath + `/send-report`, { ...params });
    }

    async logout(): Promise<void> {
        await this.getInstance().post<void>(this.basePath + '/logout');
    }

    async existsReport(params: SandboxExistsReportDTO): Promise<{ exists: boolean, report_type: string }> {
        const { data } = await this.getInstance().get<{ exists: boolean, report_type: string }>(this.basePath + `/exists-report`, { params });
        return data;
    }
}

const Service = Object.freeze(new SandboxService());
export { Service };
